import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsDatepickerModule } from '@lcs/shared/datepicker';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { TwoColumnLayoutModule } from 'src/app/common-components/column-layouts/two-column-layout/two-column-layout.module';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { LcsSingleSelectModule } from 'src/app/common-components/entity-select/single-select/single-select.module';
import { FileUploadModule } from 'src/app/common-components/file-upload/file-upload.module';
import { FormFooterModule } from 'src/app/common-components/form-footer/form-footer.module';
import { UpdateDetailsModule } from 'src/app/common-components/update-details/update-details.module';
import { FileUrlPipeModule } from 'src/app/pipes/file-url-pipe/file-url-pipe.module';
import { LocationModule } from 'src/app/pipes/location/location.module';
import { AddSpacesPipeModule } from 'src/app/pipes/split-enum-strings/add-spaces-pipe.module';
import { ErrorPageModule } from '../error-page/error-page.module';
import { PromptDetailComponent } from './containers/prompt-detail.component';
import { PromptDetailEffects } from './state/prompt-detail.effects';
import * as fromPromptDetail from './state/prompt-detail.reducer';
import { PromptDetailViewComponent } from './views/prompt-detail-view.component';

@NgModule({
   declarations: [PromptDetailViewComponent, PromptDetailComponent],
   exports: [PromptDetailComponent],
   imports: [
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      RouterModule,
      MatInputModule,
      MatRadioModule,
      MatIconModule,
      MatMenuModule,
      MatButtonModule,
      MatTooltipModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      LcsDatepickerModule,
      TwoColumnLayoutModule,
      FormFooterModule,
      MatSelectModule,
      LocationModule,
      LcsSingleSelectModule,
      EntitySelectModule,
      StoreModule.forFeature(fromPromptDetail.promptDetailFeatureKey, fromPromptDetail.reducer),
      EffectsModule.forFeature([PromptDetailEffects]),
      AppRoutingModule,
      UpdateDetailsModule,
      FileUploadModule,
      FileUrlPipeModule,
      AddSpacesPipeModule,
      ErrorPageModule,
      MatCardModule,
   ],
})
export class PromptDetailModule {}
